<template>
    <div class="lx-form-item lx-relative" :class="[`lx-form-item-${size}`, `lx-form-item-${align}`]">
        <label v-if="label" class="lx-flex-shrink-0 lx-label" :style="{ width: labelWidth }">
            <span :class="[{ asterisk: required }]">{{ label }}</span>
        </label>
        <div class="lx-form-item-content lx-flex-grow-1">
            <slot />
        </div>
        <div v-if="error" class="lx-invalid-feedback" :style="{ left: labelWidth }">{{ error }}</div>
    </div>
</template>
<script>
export default {
    name: "LxFormItem",
    props: {
        label: {
            type: String,
            default: "",
        }, // label名称
        labelWidth: {
            type: String,
            default: "100px",
        }, // label的宽度
        prop: {
            type: String,
            default: "",
        }, // 表单域字段
        align: {
            type: String,
            default: "horizontal",
            validator: (value) => {
                return ["horizontal", "vertical", "normal"].includes(value);
            }, // 排列方式
        },
        required: {
            type: Boolean,
            default: false,
        }, // 是否必选/是否显示星星标识
        error: {
            type: String,
            default: "",
        }, // 表单验证错误提示信息
        size: {
            default: "medium",
            validator: (value) => {
                return ["large", "medium", "small"].includes(value);
            },
        },
    },
    data() {
        return {};
    },
};
</script>
<style lang="scss" scoped>
.lx-form-item {
    display: flex;
    margin-bottom: 20px;
    &.lx-form-item-horizontal,
    &.lx-form-item-normal {
        justify-content: center;
        .lx-label {
            box-sizing: border-box;
            padding-right: 15px;
            .asterisk {
                margin-bottom: 0;
            }
        }
    }
    &.lx-form-item-horizontal {
        align-items: center;
    }
    &.lx-form-item-vertical {
        flex-direction: column;
    }
    &.lx-form-item-normal {
        align-items: flex-start;
    }
    &.lx-form-item-large {
        font-size: 18px;
    }
    &.lx-form-item-medium {
        font-size: 14px;
    }
    &.lx-form-item-small {
        font-size: 14px;
    }
    .lx-label {
        color: #616674;
        &.asterisk {
            margin-bottom: 15px;
        }
    }
    .lx-invalid-feedback {
        position: absolute;
        bottom: -20px;
        left: 2px;
        width: 100%;
        margin-top: 5px;
        font-size: 12px;
        color: #fd7778;
        letter-spacing: 0.5px;
    }
}
</style>
